export const PROFILE_QUERY_MAP = new Map([
  ['profile_details', 'profile_details'],
  ['data_issue', 'data_issue'],
]);

export * from './profilesApi';
export { default as useGetVolumeByLocation } from './useGetVolumeByLocation';
export { default as useNewGetVolumeByLocation } from './useNewGetVolumeByLocation';
export { default as useGetTopProviders } from './useGetTopProviders';
export { default as useMenuContent } from './useMenuContent';
export type { ProfileTab, TabChild } from './useMenuContent';
export { default as useOverflowTabs } from './useOverflowTabs';
export { default as useGetEntityDetailsById } from './useGetEntityDetailsById';
export { default as useProfileSelections } from './useProfileSelections';
export { default as useGetNewTopProviders } from './useGetNewTopProviders';
export { default as useProfileDisplayConfig } from './useProfileDisplayConfig';
